import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './send_success.less'
import { getI18n } from 'client/i18n'
import { formatMoney } from 'client/griffin'
import { Link } from 'react-router'
import { glimpselessRoute } from 'lib/route_utils'

const i18n = getI18n('components/send_glimpse/send_success')

class SendSuccess extends React.Component {
  static propTypes = {
    goalName: PropTypes.string,
    amount: PropTypes.number,
    currency: PropTypes.string,
    location: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  }

  render() {
    return (
      <div>
        <span
          className="icon icon-large icon-circled-checkmark-large"
          styleName="success-indicator"
        />
        <div styleName="title">
          {i18n('title', {
            title: this.props.goalName,
            amount: formatMoney(this.props.currency, this.props.amount),
          })}
        </div>
        <Link
          to={glimpselessRoute('send')}
          className="vx_btn vx_btn-block"
          styleName="done-button"
          data-nemo="done"
        >
          {i18n('done')}
        </Link>
      </div>
    )
  }
}

export default cssModules(SendSuccess, styles)
